/**
 * Levensduur van een JWT zoals de server hem uitgaf (exp - iat), in ms. Bewust een duur en
 * geen tijdstip: exp rechtstreeks met de toestelklok vergelijken faalt bij een scheve klok.
 * Undefined als het token geen leesbare JWT is; de handtekening wordt hier niet gecontroleerd.
 */
export function jwtLifetimeMS(token: string): number | undefined {
  const payload = token.split(' ').pop()?.split('.')[1];
  if (!payload) return undefined;

  let claims: { iat?: unknown; nbf?: unknown; exp?: unknown } | null;
  try {
    claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return undefined;
  }
  if (typeof claims !== 'object' || claims === null) return undefined;

  const issuedAt = claims.iat ?? claims.nbf;
  if (typeof issuedAt !== 'number' || typeof claims.exp !== 'number' || claims.exp <= issuedAt) {
    return undefined;
  }
  return (claims.exp - issuedAt) * 1000;
}
